<template>
<div>
<StudentHistorySearch/>

</div>
</template>
<script>
import StudentHistorySearch from "../../components/Financial/StudentHistorySearch.vue";

export default {
  beforeCreate: function() {
        document.body.className = 'iner';
    },
  components: {
   StudentHistorySearch
  },
  data() {
    return {
      content: ''
    };
  },
  created() {

  }
};
</script>

<style>


</style>